export default __webpack_public_path__ + "static/media/court.963d4f5c.svg";